///////// polyfills

// dialog polyfill for IE and Firefox
require('../../../Scripts/Polyfills/dialog-polyfill.min.js');
require('../../../Scripts/Polyfills/includes.js');

///////// libs

require('lodash');

// jquery need to be at the top
window.$ = window.jQuery = require('jquery');

// jquery libs
require('dotdotdot');

// movefocus dependencie
require('../../../Scripts/jquery.selector.focusable.js');

// dynamic content
require('../../../DynamicContent2Style/Carousel.js');

///////// Angular
require('angular');
require('angular-ui-router');
require('angular-animate');
require('angular-messages');
require('angular-sanitize');
require('angular-aria');
require('../../../Scripts/ui-bootstrap-custom-build/ui-bootstrap-custom-tpls-1.3.2');
require('restangular');
require('oclazyload');
require('../../lib/js/angular-performance');
require('../../lib/js/slick.js');
require('../../lib/js/angular-slick.js');

// Icon font loader
require('../../../Scripts/Digital-Fonts-JS-BC.js');



/** WEBPACK FOOTER **
 ** ./wowapp/src/vendor/vendor.module.js
 **/